export default "__VITE_ASSET__DsmBoxa7__"